// profileWsService.ts
import { EventEmitter } from 'events';

class ProfileWebSocketService {
  private socket: WebSocket | null = null;

  private currentUrl: string | null = null;

  private eventEmitter = new EventEmitter();

  /**
   * Function to connect socket
   * @param url
   */
  connect(url: string) {
    if (
      this.socket &&
      this.currentUrl === url &&
      (this.socket.readyState === WebSocket.OPEN || this.socket.readyState === WebSocket.CONNECTING)
    ) {
      console.log('Profile WebSocket already connected or connecting to:', url);
      return;
    }

    if (this.socket) {
      console.log('Closing existing Profile WebSocket before reconnecting');
      this.socket.close(1000, 'Reconnecting');
    }

    this.currentUrl = url;
    this.socket = new WebSocket(url);

    /**
     * onopen
     */
    this.socket.onopen = () => {
      console.log('Profile WebSocket connected to:', url);
    };

    /**
     * onmessage
     */
    this.socket.onmessage = (event) => {
      try {
        const receivedData: any = JSON.parse(event.data);
        console.log(
          'Profile WebSocket received message event:',
          receivedData.event || 'No event field',
        );
        this.eventEmitter.emit('message', receivedData);
      } catch (error) {
        console.error('Profile WebSocket parsing error:', error);
      }
    };

    /**
     * Console websocket error
     */
    this.socket.onerror = (error) => {
      console.error('Profile WebSocket error:', error);
    };

    /**
     * Console when web socket connection closes
     */
    this.socket.onclose = (event) => {
      console.log(`Profile WebSocket disconnected. Code: ${event.code}, Reason: ${event.reason}`);
    };
  }

  // /**
  //  * Function to disconnect socket
  //  */
  // disconnect() {
  //     if (this.socket) {
  //         this.socket.close();
  //         this.socket = null;
  //     }
  // }

  /**
   * Function to establish listener from a component
   * @param callback
   */
  subscribe(callback: (data: any) => void) {
    this.eventEmitter.on('message', callback);
  }

  /**
   * Function to disable/off connection to a event listener
   * @param callback
   */
  unsubscribe(callback: (data: any) => void) {
    this.eventEmitter.off('message', callback);
  }
}

const profileWebSocketService = new ProfileWebSocketService();
export default profileWebSocketService;
